import React, { Component, Fragment } from "react";
import Row from "../../containers/row";
import TwoCol from "../../containers/twoCol";
import TitleBar from "../../titleBar";
import Button from "../../button";
import ImageGrid from "../../cols/ImageGridBlock";
import CircleBlock from "../../cols/CircleBlock";
import SquareBlock from "../../cols/SquareBlock";
import Gutters from "../../config/gutters";
import RectangleBlock from "../../cols/RectangleBlock";
import Styles from "./styles/styles";
import TitleWithDescription from "../../cols/TitleWithDescription";
import FactoidBlock from "../../cols/FactoidBlock";
import YouTubeBlock from "../../cols/YoutTubeBlock";
import VideoBlock from "../../cols/VideoBlock";
import ImageWithDescription from "../../cols/ImageWithDescription";
import BlockStyle from "../../config/blockstyle";
import ScriptTag from "react-script-tag";

let left = false;

class FiftyFitfyRow extends Component {
  /*- Make each col add images if two background images have been uploaded and the second one does
        not contain the word mobile -- having the word mobile flags the image set as full width image and mobile pairing
    -*/
  makeCols(row, index) {
    //console.log("->", this.props);
    left = !left;
    let { inner_top, inner_btm } = this.props.blockStyle;
    let innerTopGutter = Gutters.spacings[inner_top];
    const titleClassName = this.props.blockStyle.name.replace(" ", "-");
    if (typeof this.props.row.field_text_1 !== "undefined") {
      innerTopGutter += window.innerWidth < 900 ? 104 : 48;
    }
    if (
      typeof this.props.row.field_text_1 !== "undefined" &&
      !left &&
      window.innerWidth < 900
    ) {
      innerTopGutter = Gutters.spacings[inner_top];
    }
    let width = window.innerWidth;
    let circleFactPosition = {
      margin: index > 0 ? "0px auto 0 auto" : "64px auto 0 auto",
      maxWidth: "313px",
      width: width,
    };

    let bgImage = "";
    let colHeight = "auto";
    let padding =
      innerTopGutter + "px 24px " + Gutters.spacings[inner_btm] + "px 24px";
    let linkColor = this.props.blockStyle.attributes.field_link_colors.name;
    if (
      typeof this.props.blockStyle.attributes.field_image !== "undefined" &&
      typeof this.props.blockStyle.attributes.field_image_1 !== "undefined" &&
      this.props.blockStyle.attributes.field_image_1.uri.indexOf("mobile") < 0
    ) {
      padding =
        innerTopGutter + "px 24px " + Gutters.spacings[inner_btm] + "px 24px";
      if (left) {
        bgImage = this.props.blockStyle.attributes.field_image.uri;
      } else {
        bgImage = this.props.blockStyle.attributes.field_image_1.uri;
      }
      if (window.innerWidth < 900) {
        padding =
          innerTopGutter + "px 24px " + Gutters.spacings[inner_btm] + "px 24px";
      }
    }

    let titleStyles = this.props.blockStyle.attributes
      .field_title_color_font[0];
    let blockStyle =
      typeof this.props.block_style != "undefined"
        ? this.props.block_style
        : BlockStyle;
    let ImageBG = [];

    if (bgImage !== "") {
      if (window.innerWidth > 900) {
        bgImage = bgImage.replace("styles/1200/public", "styles/600/public");
        colHeight =
          this.props.blockStyle.attributes.field_image_1.height600 + "px";
      } else if (window.innerWidth > 600) {
        bgImage = bgImage.replace("styles/1200/public", "styles/900/public");
        colHeight =
          this.props.blockStyle.attributes.field_image_1.height900 + "px";
      } else if (window.innerWidth < 600) {
        bgImage = bgImage.replace("styles/1200/public", "styles/360/public");
        colHeight =
          (this.props.blockStyle.attributes.field_image_1.height600 *
            window.innerWidth) /
            600 +
          "px";
      }
      if (!left) {
        colHeight = "auto";
      }
      //colHeight="auto"

      ImageBG = {
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
      };
    } else {
      ImageBG = { boxSizing: "border-box" };
    }

    switch (row.bundle) {
      /*- Title with description -- this is just text with a heading -*/
      case "title_with_description":
        return (
          <TitleWithDescription
            Styles={Styles}
            row={row}
            linkColor={linkColor}
            padding={padding}
            colHeight={colHeight}
            bgColor={
              left
                ? this.props.blockStyle.attributes.field_color_1
                : typeof this.props.blockStyle.attributes.field_bgcolor_1 ===
                  "undefined"
                ? this.props.blockStyle.attributes.field_color_1
                : this.props.blockStyle.attributes.field_bgcolor_1
            }
            ImageBG={ImageBG}
            bgImage={bgImage}
            left={left}
            field_boolean_2={this.props.row.field_boolean_2}
            titleStyles={titleStyles}
            attributes={this.props.blockStyle.attributes}
            item={this.props.item}
            title={this.props.row.field_text_1}
          />
        );
      /*- Circle Factoids -- this is the small display single factoid with a circle around the number -*/
      case "factoid":
        if (width < 900) {
          circleFactPosition = {
            width: width - 10,
            padding: "0px",
            margin: "0px auto",
          };
        }

        return (
          <FactoidBlock
            row={row}
            linkColor={linkColor}
            padding={padding}
            colHeight={colHeight}
            ImageBG={ImageBG}
            circleFactPosition={circleFactPosition}
            item_id={this.props.row.item_id}
          />
        );
      case "javascript_embed_p":
        const script =
          typeof this.props.row.field_row_content[0].field_media_half[0]
            .field_javascript_embed !== "undefined"
            ? this.props.row.field_row_content[0].field_media_half[0]
                .field_javascript_embed
            : null;
        return (
          <>
            {typeof script.code !== "undefined" ? (
              <ScriptTag type="text/javascript">
                {
                  this.props.row.field_row_content[0].field_media_half[0]
                    .field_javascript_embed.code
                }
              </ScriptTag>
            ) : null}
            {typeof script.url !== "undefined" ? (
              <ScriptTag
                type="text/javascript"
                src={
                  this.props.row.field_row_content[0].field_media_half[0]
                    .field_javascript_embed.url
                }
              />
            ) : null}
            {typeof script.css !== "undefined" ? (
              <style
                dangerouslySetInnerHTML={{
                  __html: script.css,
                }}
              />
            ) : null}
            {typeof script.tag !== "undefined" ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: script.tag,
                }}
              />
            ) : null}
          </>
        );

      /*- VIDEO -- Umm duh it creates a video for use in a single column uploaded or youtube -*/
      case "video_with_description":
        if (row.field_link_2.url.indexOf("youtube") >= 0) {
          //
          return (
            <YouTubeBlock
              attributes={this.props.blockStyle.attributes}
              row={row}
              linkColor={linkColor}
              title={this.props.row.field_text_1}
              padding={padding}
              ImageBG={ImageBG}
              left={left}
              field_boolean_2={this.props.row.field_boolean_2}
              titleStyles={titleStyles}
              Styles={Styles}
            />
          );
        } else if (row.field_link_2.url.indexOf(".mp4") >= 0) {
          return (
            <VideoBlock
              attributes={this.props.blockStyle.attributes}
              row={row}
              linkColor={linkColor}
              token={this.props.token}
            />
          );
        }
        break;
      /*---- Image with Description this is a background image with a head and text overlay----------*/
      case "image_with_description":
        return (
          <ImageWithDescription
            Styles={Styles}
            title={this.props.row.field_text_1}
            row={row}
            linkColor={linkColor}
            padding={padding}
            colHeight={colHeight}
            bgColor={
              left
                ? this.props.blockStyle.attributes.field_color_1
                : this.props.blockStyle.attributes.field_bgcolor_1
            }
            ImageBG={ImageBG}
            bgImage={bgImage}
            left={left}
            field_boolean_2={this.props.row.field_boolean_2}
            titleStyles={titleStyles}
            attributes={this.props.blockStyle.attributes}
            item={this.props.item}
          />
        );
      /*- IMAGE GRID */

      case "image_grid":
        return (
          <TwoCol
            className={linkColor}
            styles={{ ...ImageBG, height: colHeight }}
          >
            {left &&
            bgImage !== null &&
            this.props.row.field_boolean_2 !== "0" ? (
              <TitleBar
                className={titleClassName}
                divStyle={Styles.divStyle}
                color={titleStyles.field_color_1}
                bgc={titleStyles.field_bgcolor_1}
                fontFamily={titleStyles.field_font_1.name}
                max="19"
                min="16"
                container="Left"
                tag="h2"
              >
                {this.props.row.field_text_1}
              </TitleBar>
            ) : (
              ""
            )}
            <ImageGrid
              title={this.props.title}
              rowData={row.field_images}
              blockStyle={this.props.blockStyle}
            />
          </TwoCol>
        );
      /*- THREE IMAGE LINKS */
      case "three_image_links":
        switch (row.field_image_display) {
          case "circle":
            return (
              <CircleBlock
                rowData={row.field_image_link}
                blockStyle={blockStyle}
              />
            );
          case "square":
            return (
              <SquareBlock
                rowData={row.field_image_link}
                blockStyle={blockStyle}
              />
            );
          case "textless":
            return (
              <SquareBlock
                rowData={row.field_image_link}
                blockStyle={blockStyle}
              />
            );
          case "rectangle":
            return (
              <RectangleBlock
                rowData={row.field_image_link}
                blockStyle={blockStyle}
              />
            );

          default:
            return <p>Unknown Version of Three Image links</p>;
        }

      default:
        return <p>No Data</p>;
    }
  }
  /* ----------------Create full Row Backgorunds -----------*/
  returnBackground(background) {
    let bg = {
      bgimg: "",
      bgc: background.attributes.field_color_1,
      height: "",
    };
    let width = window.innerWidth;
    if (
      typeof this.props.blockStyle.attributes.field_image !== "undefined" &&
      typeof this.props.blockStyle.attributes.field_image_1 !== "undefined" &&
      typeof this.props.blockStyle.attributes.field_image_1 !== "undefined" &&
      this.props.blockStyle.attributes.field_image_1.uri.indexOf("mobile") < 0
    ) {
      bg.height = this.props.blockStyle.attributes.field_image.height;

      return bg;
    }
    /*-----Image Overide from row begin---------*/
    if (typeof this.props.row.field_image !== "undefined") {
      //TODO use utility function
      if (width < 900) {
        if (typeof this.props.row.field_image_1 !== "undefined") {
          bg.bgimg = this.props.row.field_image_1.uri;
        }
      } else bg.bgimg = this.props.row.field_image.uri;
      bg.bgc = "";
      bg.height = this.props.row.field_image.height;
      /*------Image defined in styles begin----------*/
    } else if (typeof background.attributes.field_image !== "undefined") {
      bg.bgc = "";
      if (width > 899) {
        bg.bgimg = background.attributes.field_image.uri;
        bg.bgh = background.attributes.field_image.height;
      } else if (
        typeof background.attributes.field_image_1 !== "undefined" &&
        background.attributes.field_image_1.uri.indexOf("nomobile") < 0
      ) {
        bg.bgimg = background.attributes.field_image_1.uri;
        bg.bgh = background.attributes.field_image_1.height900;
      }
      bg.boxText = false;
      /*------Background Color as Default---------------------*/
    } else {
      bg.bgimg = "none";
      bg.bgc =
        background.attributes.field_background_options === "one"
          ? background.attributes.field_color_1
          : "transparent";
    }
    return bg;
  }
  makeArrowButtons(linkField) {
    return linkField.map((button, index) => (
      <Fragment key={index}>
        <Button
          id={"item" + this.props.item + "_button" + index}
          styles={{ textTransform: "uppercase", fontFamily: "Oswald" }}
          className="GreenButtonWithArrow"
        >
          {button.title}
        </Button>
      </Fragment>
    ));
  }
  returnRows() {
    let media = this.props.row.field_row_content[0];

    if (typeof media.field_media_half !== "undefined") {
      return media.field_media_half.map((row, index) => (
        <Fragment key={index}>{this.makeCols(row, index)}</Fragment>
      ));
    } else {
      return "Missing Fields " + media.bundle;
    }
  }
  render() {
    let bg = "";
    let margin =
      Gutters.spacings[this.props.blockStyle.top] +
      "px 0px " +
      Gutters.spacings[this.props.blockStyle.btm] +
      "px 0px";
    let padding = "0px";

    //let show = false;

    if (typeof this.props.blockStyle != "undefined") {
      bg = this.returnBackground(this.props.blockStyle);
    }
    return (
      <Row
        margin={margin}
        padding={padding}
        bgi={bg.bgimg}
        bgc={bg.bgc}
        bgh={bg.bgh}
        bgSize={window.innerWidth < 900 ? "cover" : "contain"}
        className="5050"
      >
        {this.returnRows()}
      </Row>
    );
  }
}

export default FiftyFitfyRow;
